import "./styles.scss";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import queryString from "query-string";

import { useClientTasks } from "context/admin/client_tasks";
import useResponsive from "libs/helpers/useResponsive";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import TasksTable from "./TasksTable";
import TasksTiles from "./TasksTiles";
import {
  StatusExplanation,
  PriorityExplanation,
} from "page_components/shared/tasks/explanations";

const actions = [{ type: "send_notification" }, { type: "create_task" }];

const mainClass = "clients-admin-tasks";

const TasksContent = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { search } = location;
  const { client_status, client_sort, client_page } = queryString.parse(search);
  const clientReturnQuery = queryString.stringify({
    client_status,
    client_sort,
    client_page,
  });
  const clientDetailsUrl = `/clients/${id}${
    clientReturnQuery ? `?${clientReturnQuery}` : ""
  }`;
  const { max } = useResponsive();
  const { data, init_loading } = useClientTasks();
  const [explanation, setExplanation] = useState(null);
  const [website, setWebsite] = useState(null);

  const description = `${t("Clients")}${website ? ` / ${website}` : " / -"}`;

  useEffect(() => {
    if (data?.website) setWebsite(data.website);
  }, [data?.website]);

  return (
    <>
      <DashboardContentLayout
        backMobile={() => navigate(clientDetailsUrl)}
        header={{
          label: t("Tasks"),
          description: max.sm
            ? description
            : {
                value: description,
                onClick: () => navigate(clientDetailsUrl),
              },
        }}
        loading={init_loading}
        actions={actions}
      >
        <div className={mainClass}>
          {!max.lg ? (
            <TasksTable
              setExplanation={setExplanation}
              returnTo={`${location.pathname}${location.search}`}
            />
          ) : (
            <TasksTiles
              setExplanation={setExplanation}
              returnTo={`${location.pathname}${location.search}`}
            />
          )}
        </div>
      </DashboardContentLayout>

      <StatusExplanation
        isOpen={explanation === "status"}
        onClose={() => setExplanation(null)}
      />
      <PriorityExplanation
        isOpen={explanation === "priority"}
        onClose={() => setExplanation(null)}
      />
    </>
  );
};

export default TasksContent;
